import { useCallback } from "react"

import { useFilterFieldsOverride } from "~/hooks/useFilterFieldsOverride"
import { useExtraDataTypeMap } from "~/hooks/useSku"
import { ExtraDataTable, getExtraDataType } from "~/utils/dynamicTableUtils"
import { filterFields } from "~/utils/filter"

// Resolves the logical type ("number" | "string" | "date" | "enum" | ...) for any
// filter field — static fields from `filterFields` plus dynamic SKU /
// collection / incoming-order extra data fields. Used by `applyFilter` so it can
// dispatch number/date/string comparators correctly when JSON values lose their
// type round-tripping through the column store.
export function useFilterFieldTypeResolver() {
  const { data: typeMap } = useExtraDataTypeMap()
  const override = useFilterFieldsOverride()

  return useCallback(
    (field: string): string | undefined => {
      if (override) return override.fields.find((f) => f.value === field)?.type
      if (field.includes("(extradata)")) {
        return getExtraDataType(field.replace("(extradata)", ""), ExtraDataTable.SKU, typeMap)
      }
      if (field.includes("(collection-extradata)")) {
        return getExtraDataType(
          field.replace("(collection-extradata)", ""),
          ExtraDataTable.COLLECTION_ON_SKU,
          typeMap,
        )
      }
      if (field.includes("(incoming-order-extradata)")) {
        return getExtraDataType(
          field.replace("(incoming-order-extradata)", ""),
          ExtraDataTable.INCOMING_ORDER_ITEM,
          typeMap,
        )
      }
      return filterFields.find((f) => f.value === field)?.type
    },
    [override, typeMap],
  )
}
